<template>
  <div>
    <app-heading
      :text="'Service Qualification'"
      :heading="'main'"
    ></app-heading>
    <qualification-form
      ref="qualificationForm"
      @showResultSection="showResultSection"
      @toggleInput="toggleInput"
      @changed="changed"
    ></qualification-form>
    <v-divider class="mt-6 mb-4"></v-divider>
    <qualification-result
      ref="qualificationResult"
      v-if="showResult"
      :showButtons="true"
      :showLocIdInput="showLocIdInput"
      :queryAddress="queryAddress"
      :enable="enable"
      :hideOtherButtons="false"
      :withData="true"
      :showHeading="true"
      :hasMultipleLocId="hasMultipleLocId"
      @createOrder="setNewOrder"
    ></qualification-result>
    <create-order
      ref="createOrder"
      :showNewOrder="showNewOrder"
      @close="closeNewOrder()"
    ></create-order>
  </div>
</template>

<script>
export default {
  name: "ServiceQualification",
  data: () => ({
    showNewOrder: false,
    enable: false,
    showResult: false,
    queryAddress: [],
    streetAddress: "",
    populatedAddress: {},
    showLocIdInput: false,
    id: "",
    hasMultipleLocId: true,
    primaryAccessTechnology: "",
  }),
  methods: {
    closeNewOrder() {
      let vm = this;
      vm.showNewOrder = false;
    },
    showResultSection(details) {
      let vm = this;
      vm.queryAddress = details.queryAddress;
      vm.streetAddress = details.streetAddress;
      vm.populatedAddress = details.populatedAddress;

      if (
        details.queryAddress.length === 1 &&
        details.queryAddress.length !== 0
      ) {
        vm.hasMultipleLocId = false;
        vm.setLocationID(vm.queryAddress[0].locationId);
        vm.serviceQualification(details.queryAddress[0]).then((data) => {
          data.data.parameters.parameter.forEach((x) => {
            if (x.name === "PrimaryAccessTechnology")
              vm.primaryAccessTechnology = x.value;
          });
          vm.getExcludedProducts(vm.primaryAccessTechnology).then(() => {
            if (vm.isProductExcluded) {
              vm.setHttpResponse({
                text: vm.invalidProductErr,
                color: "error",
              });
            }
          });

          vm.setFormattedSQResult(data.data);
          vm.showResult = true;

          this.$nextTick(() => {
            vm.$refs.qualificationResult.result = data.data;
          });
        });
      } else vm.showResult = true;
    },
    async setNewOrder() {
      let vm = this;

      // let request = await vm.createNewOrder({
      //   locationId: "LOC000059754013",
      //   customerAuthDate: new Date(),
      //   contractLength: 12,
      // });
      // debugger;

      vm.showNewOrder = true;
      //vm.$refs.createOrder.details = data;

      // if (data.sqResult.parameters.parameterGroup) {
      //   vm.$refs.createOrder.ntd = data.sqResult.parameters.parameterGroup.map(
      //     (x) => x.groupName
      //   );

      //   if (data.sqResult.parameters.parameterGroup.length === 1) {
      //     vm.$refs.createOrder.unid = data.sqResult.parameters.parameterGroup[0].parameter.filter(
      //       (x) => x.name.includes("UNI-D")
      //     );
      //   } else {
      //     vm.$refs.createOrder.unid = [];
      //   }

      //   vm.$refs.createOrder.newOrder = {
      //     locationId: vm.locationID,
      //     orderType: "",
      //     customerAuthDate: "",
      //     requestedSpeed: "",
      //     contractTerm: "",
      //     customer: {
      //       firstName: "",
      //       lastName: "",
      //       contactNo: "",
      //       email: "",
      //     },
      //     operatorContactEmail: "",
      //     operatorContactNumber: "",
      //     serviceId: data.sqResult.correlationId,
      //     accessLoopId: vm.formattedSQResult.csaid
      //       ? vm.formattedSQResult.csaid
      //       : "",
      //     operatorFirstname: "",
      //     operatorSurname: "",
      //     customerReference: data.sqResult.correlationId,
      //     cpiID:
      //       data.sqResult.parameters.parameterGroup.length === 1
      //         ? data.sqResult.parameters.parameterGroup[0].groupName
      //         : "",
      //     unidPortID: "",
      //     installationWorkforce: "",
      //     portingNumber: 0,
      //     specialInstructions: "",
      //     deliveryInstructions: "",
      //     ticketId: data.sqResult.correlationId,
      //   };
      // }
    },
    toggleInput(state) {
      let vm = this;
      vm.showResult = state;
      vm.showLocIdInput = state;
    },
    changed() {
      let vm = this;
      vm.showResult = false;
      vm.hasMultipleLocId = true;
    },
  },
  computed: {
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
  },
};
</script>

<style lang="scss" scoped></style>